"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * @file
 * R4V tables.
 */
(function ($, Drupal) {
  'use strict';

  var baseConfig = {
    two_percentage_column: {
      minWidth: 500,
      flex: 1,
      type: 'combo',
      sorter: function sorter(order, a, b) {
        try {
          var valA = a[1];
          var valB = b[1];
          return order === 'asc' ? valA - valB : valB - valA;
        } catch (error) {
          return 0;
        }
      },
      render: function render(o) {
        try {
          var maxVal = o.column.getMaxValue(o.column.index, 1);
          o.value = renderTwoPercentage(o.data, o.column.index, maxVal);
          return o;
        } catch (error) {
          return 'Error en la data.';
        }
      }
    },
    relative_circle: {
      render: function render(o) {
        try {
          var maxVal = o.column.getMaxValue(o.column.index);
          o.value = renderCircle(o.data, o.column.index, maxVal);
          return o;
        } catch (error) {
          return 'Data error.';
        }
      }
    },
    bar_column: {
      minWidth: 200,
      flex: 1,
      render: function render(o) {
        try {
          var maxVal = o.column.getMaxValue(o.column.index);
          o.value = renderBar(o.data, o.column.index, maxVal);
          return o;
        } catch (error) {
          return 'Data error.';
        }
      }
    },
    percentage_pie: {
      minWidth: 125,
      flex: 1,
      headerCls: 'fsize-1',
      render: function render(o) {
        try {
          o.value = renderPie(o.data, o.column.index);
          return o;
        } catch (error) {
          return 'Data error.';
        }
      }
    },
    table_text: {
      minWidth: 250,
      flex: 1,
      headerCls: 'fsize-1'
    },
    table_link: {
      minWidth: 250,
      flex: 1,
      headerCls: 'fsize-1'
    }
  };
  Drupal.behaviors.r4vTables = {
    attach: function attach(context, settings) {
      var tables = context.querySelectorAll('.r4v-table');

      if (!tables.length) {
        return;
      }

      Fancy.defineTheme('r4v', {
        config: {
          cellHeaderHeight: 45,
          cellHeight: 42
        }
      });

      if (settings.hasOwnProperty('tables')) {
        for (var id in settings.tables) {
          useFancyGrid(id, settings.tables[id]);
        }
      }
    }
  };

  function _getMaxValue(values, key, i) {
    if (!values.length) {
      return;
    }

    return values.map(function (row) {
      return i > -1 ? row[key][i] : row[key];
    }).reduce(function (max, curr) {
      return Math.max(max, curr);
    });
  }

  function renderTwoPercentage(column, key, maxVal) {
    if (!column[key].length) {
      return '';
    }

    var _column$key = _slicedToArray(column[key], 2),
        val1 = _column$key[0],
        val2 = _column$key[1];

    var barWidth = Math.round(val2 / maxVal * 100);
    var innerBarWidth = Math.round(val1 / val2 * 100);
    return "\n      <div class=\"bar\">\n        <span class=\"bar__value bar__value--left numbers__number c-primary\" style=\"flex-basis: 65px\">".concat(formatBarLabel(val1), "</span>\n        <div class=\"w-100\">\n          <div class=\"bar__back\" style=\"background: #0f1c2f;width:").concat(barWidth < 100 ? barWidth : 100, "%;\">\n            <div class=\"bar__front\" style=\"width:").concat(innerBarWidth < 100 ? innerBarWidth : 100, "%; height: 15px;\"></div>\n          </div>\n        </div>\n        <span class=\"bar__value bar__value--right numbers__number c-gray\" style=\"flex-basis: 65px\">").concat(formatBarLabel(val2), "</span>\n      </div>\n    ");
  }

  function renderBar(column, key, maxVal) {
    if (!column[key]) {
      return '';
    }

    var barValue = column[key];
    var barWidth = barValue / maxVal * 100;
    return "\n      <div class=\"bar\">\n        <span class=\"bar__value bar__value--left numbers__number c-primary\" style=\"flex-basis: 75px\">".concat(formatBarLabel(barValue), "</span>\n        <div class=\"bar__back\" style=\"background: #fff\">\n          <div class=\"bar__front\" style=\"width:").concat(barWidth < 100 ? barWidth : 100, "%; height: 20px;\"></div>\n        </div>\n      </div>\n    ");
  }

  function renderCircle(column, key, maxVal) {
    if (!column[key]) {
      return;
    }

    var val = column[key];
    var circleSize = Math.round(30 * (val / maxVal));
    return "\n      <div class=\"circle\">\n        ".concat(val, " <span class=\"circle__value\" style=\"width: ").concat(circleSize, "px; height: ").concat(circleSize, "px\"></span>\n      </div>\n    ");
  }

  function renderPie(column, key) {
    if (!column[key]) {
      return '';
    }

    var val = column[key];
    var left = 100 - val;
    return "\n      <div class=\"d-flex align-items-center\">\n        <span style=\"color: #0f1c2f\">".concat(val, "%</span>\n        <div class=\"pie mx-2\" style=\"background-image: conic-gradient(#0f1c2f calc(3.6deg * ").concat(val, "),#00aaad 0 calc(3.6deg * ").concat(left, "));\"></div>\n        <span style=\"color: #00aaad\">").concat(left, "%</span>\n      </div>\n    ");
  }

  function useFancyGrid(id, values) {
    var maxValues = {};
    var columns = setColumns(values.column_config);
    new FancyGrid({
      renderTo: document.getElementById(id),
      height: 'fit',
      theme: {
        name: 'blue',
        config: {
          bottomScrollHeight: 0
        }
      },
      data: {
        items: values.data
      },
      defaults: {
        type: 'number',
        resizable: true,
        getMaxValue: function getMaxValue(key, i) {
          if (typeof maxValues[key] == 'number') {
            return maxValues[key];
          }

          maxValues[key] = _getMaxValue(values.data, key, i);
          return maxValues[key];
        }
      },
      clicksToEdit: 1,
      columns: columns
    });
  }

  function setColumns(columns) {
    var result = columns.map(function (column) {
      if (!baseConfig[column.customType]) {
        return column;
      }

      return _objectSpread(_objectSpread({}, column), baseConfig[column.customType]);
    });
    return result;
  }

  function formatBarLabel(value, showPrefixes) {
    var simbol = [{
      value: 1,
      symbol: ''
    }, {
      value: 1E3,
      symbol: 'k'
    }, {
      value: 1E6,
      symbol: 'M'
    }];
    var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var i;

    for (i = simbol.length - 1; i > 0; i--) {
      if (value >= simbol[i].value) {
        break;
      }
    }

    var formatedNumber = (value / simbol[i].value).toFixed(1).replace(rx, "$1") + simbol[i].symbol;

    if (showPrefixes && showPrefixes === '1') {
      formatedNumber = '$' + formatedNumber;
    }

    return formatedNumber;
  }
})(jQuery, Drupal);